import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Loadable from 'react-loadable';
export var HubHomeAsync = Loadable({
  loader: function () {
    var _loader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_hub-studio-hub-home" */'./index');
          case 2:
            return _context.abrupt("return", _context.sent.HubHome);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function loader() {
      return _loader.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return null;
  }
});